import { useEffect, useState } from 'react';

function readViewportSize () {
    if (typeof window === 'undefined') {
        return { height: 0, width: 0 };
    }
    const vv = window.visualViewport;
    return {
        height: vv?.height ?? window.innerHeight,
        width: vv?.width ?? window.innerWidth
    };
}

/**
 * A custom React hook that returns the current dimensions of the window.
 * Uses VisualViewport when available so table scroll heights match the visible
 * area on mobile (address bar / on-screen keyboard).
 * @returns {Object} - An object containing the height and width of the window.
 */
export default function useWindowDimension () {
    const [dimensions, setDimension] = useState(() => readViewportSize());

    useEffect(() => {
        function handleResize () {
            setDimension(readViewportSize());
        }
        window.addEventListener('resize', handleResize);
        window.visualViewport?.addEventListener('resize', handleResize);
        window.visualViewport?.addEventListener('scroll', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
            window.visualViewport?.removeEventListener('resize', handleResize);
            window.visualViewport?.removeEventListener('scroll', handleResize);
        };
    }, []);

    return dimensions;
}
